export const networkFeesSelectors = {
  gridData: (state) => state.gridData,
  update: (state) => state.update,
}
